import { render } from "./Sunshine.vue?vue&type=template&id=19501b08"
import script from "./Sunshine.vue?vue&type=script&lang=js"
export * from "./Sunshine.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__